import React, { useState } from 'react'
import { useStyles } from './search-input.style'

export const SearchInput = function ({ enableFocusAnimation = true, _ref, className = '', ...props }) {
  const classes = useStyles()
  const [isFocused, setIsFocused] = useState(false)

  function handleFocus () {
    setIsFocused(true)
  }

  function handleBlur () {
    setIsFocused(false)
  }

  return (
    <div className={`form-element-wrapper font-icon-magnifying-glass ${classes.inputContainer} ${isFocused ? classes.focused : ''}`}>
      <input type="search" className={`${classes.input} ${className}`} ref={_ref} {...props} onFocus={handleFocus} onBlur={handleBlur} />
      {enableFocusAnimation && <div className="form-element-border"></div>}
    </div>
  )
}
